/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_MarketingInputs */

const cs_integrations_section_marketing = /** @type {(inputs: Integrations_Section_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing a reklama`)
};

const en_integrations_section_marketing = /** @type {(inputs: Integrations_Section_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing & ads`)
};

/**
* | output |
* | --- |
* | "Marketing & ads" |
*
* @param {Integrations_Section_MarketingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_marketing = /** @type {((inputs?: Integrations_Section_MarketingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_MarketingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_marketing(inputs)
	return cs_integrations_section_marketing(inputs)
});